import { auth } from '../config/firebase'
import { setContext } from '@apollo/client/link/context'

export const getAuthToken = async (): Promise<string | undefined> => {
    // Firebase restores the persisted session asynchronously on page load, so
    // `auth.currentUser` is null for a brief window after a refresh. Without
    // waiting, GraphQL operations that fire during that window go out with no
    // token and hit the server as unauthenticated (tripping the auth gate).
    // `authStateReady()` resolves once the initial auth state is settled
    // (with a real user, or null if genuinely signed out).
    await auth.authStateReady()

    const token = await auth.currentUser?.getIdToken()

    return token
}

export const authLink = setContext(async (_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = await getAuthToken()
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    }
})
